import React from 'react'
import Text from '../ui/Text'
import Link from '../ui/Link'

const ResourceCell = ({ collectId, draftId, resourceId, name }) => {
  if (!resourceId || !draftId)
    return <Text lines={2}>{name || '-'}</Text>
  const href = `/collects/${collectId}/drafts/${draftId}/resources/${resourceId}/sections`
  return <Link href={href} lines={2} target="_blank">{name}</Link>
}

export default ResourceCell
